module.exports = __webpack_public_path__ + "market/static/img/noAwardPic.cb182ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/noAwardPic.png
// module id = OEQn
// module chunks = 1